var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocalCouncil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Official-Building-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Official Building 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 22.5H23a0.5 0.5 0 0 1 -0.5 -0.5v-4a0.5 0.5 0 0 1 0.5 -0.5h0.25a0.75 0.75 0 0 0 0 -1.5H0.75a0.75 0.75 0 0 0 0 1.5H1a0.5 0.5 0 0 1 0.5 0.5v4a0.5 0.5 0 0 1 -0.5 0.5H0.75a0.75 0.75 0 0 0 0 1.5h22.5a0.75 0.75 0 0 0 0 -1.5ZM6 21.25a0.75 0.75 0 0 1 -1.5 0v-2.5a0.75 0.75 0 0 1 1.5 0Zm4.5 0a0.75 0.75 0 0 1 -1.5 0v-2.5a0.75 0.75 0 0 1 1.5 0Zm4.5 0a0.75 0.75 0 0 1 -1.5 0v-2.5a0.75 0.75 0 0 1 1.5 0Zm4.5 0a0.75 0.75 0 0 1 -1.5 0v-2.5a0.75 0.75 0 0 1 1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18 7.5h11.64a0.26 0.26 0 0 0 0.18 -0.11 0.26 0.26 0 0 0 0 -0.23 6.49 6.49 0 0 0 -4.66 -4 0.49 0.49 0 0 1 -0.34 -0.49V1a1 1 0 0 0 -2 0v1.67a0.49 0.49 0 0 1 -0.39 0.49 6.49 6.49 0 0 0 -4.61 4 0.26 0.26 0 0 0 0 0.23 0.26 0.26 0 0 0 0.18 0.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10H5a0.5 0.5 0 0 1 0.5 0.5v4a0.5 0.5 0 0 0 0.5 0.5h12a0.5 0.5 0 0 0 0.5 -0.5v-4a0.5 0.5 0 0 1 0.5 -0.5h0.75a0.75 0.75 0 0 0 0 -1.5H4.25a0.75 0.75 0 0 0 0 1.5Zm9.25 0.5a0.75 0.75 0 0 1 1.5 0V13a0.75 0.75 0 0 1 -1.5 0Zm-4.5 0a0.75 0.75 0 0 1 1.5 0V13A0.75 0.75 0 0 1 9 13Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocalCouncil);
export default ForwardRef;